export default "__VITE_ASSET__d0ba9e71__"